export default {
  type: 'qtrMetricsFilters',
  name: 'Quarterly Completeness Filters',
  permissions: {
    view: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    insert: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    update: { app: 'metrics_dash', role: 'metrics_qtr_data' },
    delete: { app: 'metrics_dash', role: 'metrics_qtr_data' }
  },
  search: {
    search: 'allQtrMetricsFilters',
    orderBy: {
      type: 'QtrMetricsFiltersOrderBy',
      default: 'VALUE_ASC'
    },
    fields: [
      {
        name: 'field',
        order: 'FIELD',
        type: 'select',
        options: [
          { value: null, text: 'All' },
          { value: 'datastream', text: 'Datastream' },
          { value: 'site_code', text: 'Site Code' },
          { value: 'instrument_code', text: 'Instrument Code' },
          { value: 'data_level_code', text: 'Data Levl Code' },
          { value: 'facility_code', text: 'Facility Code' },
          { value: 'force_ds', text: 'Force a Datastream' }
        ]
      },
      {
        name: 'value',
        order: 'VALUE'
      },
      {
        name: 'startDate',
        order: 'START_DATE',
        searchable: false
      },
      {
        name: 'endDate',
        order: 'END_DATE',
        searchable: false
      },
      {
        name: 'comments',
        order: 'COMMENTS',
        searchable: false
      }
    ]
  },
  save: {
    fields: [
      {
        field: 'id',
        type: 'Int',
        required: true
      },
      {
        field: 'field',
        required: true
      },
      {
        field: 'value',
        required: true
      },
      {
        field: 'startDate',
        type: 'Date'
      },
      {
        field: 'endDate',
        type: 'Date'
      },
      'comments'
    ],
    key: ['id'],
    input: 'qtrMetricsFilter',
    create: 'createQtrMetricsFilter',
    delete: 'deleteQtrMetricsFilter',
    update: 'updateQtrMetricsFilter'
  },
  load: {
    nodeId: 'qtrMetricsFilter',
    key: 'qtrMetricsFilterById'
  },
  form: {
    print: false,
    schema: [
      {
        name: 'field',
        required: true,
        type: 'select',
        options: [
          { value: 'datastream', text: 'Datastream' },
          { value: 'site_code', text: 'Site Code' },
          { value: 'instrument_code', text: 'Instrument Code' },
          { value: 'data_level_code', text: 'Data Levl Code' },
          { value: 'facility_code', text: 'Facility Code' },
          { value: 'force_ds', text: 'Force a Datastream' }
        ]
      },
      {
        name: 'value',
        required: true
      },
      {
        name: 'startDate',
        type: 'date',
        required: true
      },
      {
        name: 'endDate',
        type: 'date'
      },
      { name: 'comments' }
    ]
  }
}
